import axios from "axios";
import config from "../config";
import {
  DocumentationStep,
  ResourceBookingSchema,
  ResourceSchema,
} from "../data/types";

const secretKey = process.env.REACT_APP_SECRET_KEY ? process.env.REACT_APP_SECRET_KEY : "";
const apiKey = process.env.REACT_APP_API_KEY ? process.env.REACT_APP_API_KEY : "";

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

axiosInstance.defaults.headers.common["HOMECOOK-SECRET-KEY"] = secretKey;
axiosInstance.defaults.headers.common["HOMECOOK-API-KEY"] = apiKey;

const unwrap = <T,>(data: any): T => (data?.body ?? data) as T;

/** Persist the documentation steps checklist on a resource. */
export const updateResourceSteps = async (
  communityId: string,
  resourceId: string,
  steps: DocumentationStep[]
): Promise<ResourceSchema | null> => {
  if (!communityId || !resourceId) return null;
  try {
    const response = await axiosInstance.put(
      `/community/${communityId}/resource/${resourceId}/steps`,
      { steps }
    );
    return unwrap<ResourceSchema>(response.data);
  } catch (error) {
    console.error("updateResourceSteps failed", error);
    return null;
  }
};

export type AddTaskActivityPayload = {
  stepId: string
  taskId: string
  message?: string
  authorName?: string
  authorAvatar?: string
  authorKind?: "user" | "agency" | "admin"
  file?: File
};

/** Append a comment and optional file to an applicant task. */
export const addBookingTaskActivity = async (
  communityId: string,
  bookingId: string,
  payload: AddTaskActivityPayload
): Promise<ResourceBookingSchema | null> => {
  if (!communityId || !bookingId || !payload.stepId || !payload.taskId) return null;
  const formData = new FormData();
  formData.append("step_id", payload.stepId);
  formData.append("task_id", payload.taskId);
  if (payload.message) formData.append("message", payload.message);
  if (payload.authorName) formData.append("author_name", payload.authorName);
  if (payload.authorAvatar) formData.append("author_avatar", payload.authorAvatar);
  if (payload.authorKind) formData.append("author_kind", payload.authorKind);
  if (payload.file) formData.append("file", payload.file);
  try {
    const response = await axiosInstance.post(
      `/community/${communityId}/bookings/${bookingId}/task-activity`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return unwrap<ResourceBookingSchema>(response.data);
  } catch (error) {
    console.error("addBookingTaskActivity failed", error);
    return null;
  }
};
